module.exports = {"title":"Audit Trails","permissions":{"view":"View Audit Trails"},"reports":{"access_control":"Access Control","activity":"Activity"}};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en/audit_trail.php
// module id = OwmP
// module chunks = 99